import React, { useState } from "react";
import { useLocation, useParams } from 'react-router-dom';
import { PageNotFound } from "../Pages/404/PageNotFound";
import { useMsal } from "@azure/msal-react";
import Loader from "../Components/Shared/Loader/loader";
import { CheckForAdminAccess } from "../Components/Helpers/miscellaneous";
import { getUserAndItsOrganizations } from "../API/Organization/organization";

export const AdminRouteRender = (props) => {
	let check = true;
	const context = useMsal();
	const location = useLocation();
	const params = useParams();

	const [state, setState] = useState({
		loading: true,
		user: {},
		isOwner: false
	});

	const checkUserIsValid = async () => {
		try {
			debugger
			let { organizations, user} = await getUserAndItsOrganizations(context.accounts[0].username)
			if (localStorage.getItem("theme") !== null) {
				document.documentElement.className = "theme-" + localStorage.getItem("theme");
			} else {
				document.documentElement.className = "theme-" + user.defaultTheme;
			}
			setState(prevState => ({
				...prevState,
				loading: false,
				user: user,
				organizations: organizations
			}));
		} catch (e) {
			setState({ showServerError: true });
		}
	};

	const requireLogin = () => {
		context.instance.loginRedirect();
	};

	if (context.inProgress !== "none") {
		return <Loader />;
	}

	if (context.accounts.length === 0) {
		requireLogin();
	}

	if (state.loading) {
		if (check) {
			checkUserIsValid();
			check = false;
		}
		return <Loader />;
	}

	if (!state.user && !state.user._id) {
		let message = (
			<span>
				Your account
				<span className="text-primary mx-1">{context.accounts[0].username}</span>
				is not authorized to view this page.
			</span>
		);
		return <PageNotFound user={state.user} status={401} statusMessage={"Uh-oh, you do not have access"} message={message} organisations={state.organizations} />;
	}

	if (!CheckForAdminAccess(context.accounts[0].username)) {
		let message = (
			<span>
				Your account
				<span className="text-primary mx-1">{context.accounts[0].username}</span>
				is not authorized to view this page.
			</span>
		);
		return <PageNotFound user={state.user} status={401} statusMessage={"Uh-oh, you do not have access"} message={message} organisations={state.organizations}/>;
	}

	if (state.showServerError) {
		let message = (
			<span>
				Oops! Sorry, the server has some issues.
				<br />
				Take a break! it will be back soon.
			</span>
		);
		return <PageNotFound user={state.user} status={500} statusMessage={"Server is offline"} message={message} organisations={[]} />;
	}

	return (
		<>
			{React.Children.map(props.children, (child) => {
				if (React.isValidElement(child)) {
					return (
						<div className="h-100 overflow-hidden d-flex flex-column">
							{React.cloneElement(child, {
								// history: history,
								location: location,
								match: params,
								user: state.user,
								newUser: context.accounts[0].idTokenClaims.newUser ? context.accounts[0].idTokenClaims.newUser : false
							})}
						</div>
					);
				}
			})}
		</>
	);
}
